export default __webpack_public_path__ + "static/media/shopping-basket.90b59d04.svg";